module.exports = __webpack_public_path__ + "static/media/cups_right.963175c1.webp";